import { useContext } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { DatePicker, FormCheckbox, FormSelect, ProductsContext } from 'components';

const TravelsFilters = () => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  const {
    tourOperatorFilters,
    countryListFilters,
    departureCityFilters,
    travelCategoryFilters,
    packageFilters,
    loadingTravels,
    loadingLeisures
  } = useContext(ProductsContext);

  const nights = [
    {
      name: t('nights', { count: '1-4' }),
      value: 2
    },
    {
      name: t('nights', { count: '5-8' }),
      value: 6
    },
    {
      name: t('nights', { count: '9-12' }),
      value: 10
    },
    {
      name: t('nights', { count: '+12' }),
      value: 14
    }
  ];

  return (
    <>
      <div className="p-6 pb-0 lg:pb-6 lg:border-b lg:border-gray-200">
        <button type="submit" className="btn secondary w-full mb-6" disabled={loadingTravels || loadingLeisures}>
          {t('buttons.search')}
        </button>

        <Controller
          render={({ field: { onChange } }) => (
            <FormSelect
              onChange={onChange}
              options={tourOperatorFilters || []}
              name="tourOperatorId"
              placeholder={t('form:select.select')}
              label={t('form:provider')}
              id="resultTravelsTourOperator"
              prefillFromParams
            />
          )}
          name="tourOperatorId"
          control={control}
          rules={{ required: true }}
        />
      </div>

      <div className="p-6 lg:border-b lg:border-gray-200">
        <Controller
          render={({ field: { onChange } }) => (
            <FormSelect
              options={countryListFilters || []}
              onChange={onChange}
              name="country"
              placeholder={t('form:placeholders.destination')}
              label={t('form:destination')}
              icon={{ name: 'location-dot', style: 'fad' }}
              className="mb-6"
              id="resultTravelsCountry"
              prefillFromParams
            />
          )}
          name="country"
          control={control}
        />

        <Controller
          render={({ field: { onChange } }) => (
            <FormSelect
              onChange={onChange}
              name="departure"
              options={departureCityFilters || []}
              placeholder="Paris, Lyon, Marseille, etc ..."
              className="mb-6"
              label={t('form:departureCity')}
              icon={{ name: 'plane-departure', style: 'fad' }}
              id="resultTravelsDeparture"
              prefillFromParams
            />
          )}
          name="departure"
          control={control}
        />

        <Controller
          control={control}
          name="dates"
          render={({ field: { onChange, value } }) => (
            <DatePicker
              onChange={onChange}
              name="dates"
              label={t('form:departureDate')}
              placeholder={t('form:placeholders.date')}
              selectsRange
              startDate={value[0]}
              endDate={value[1]}
              containerClass="relative h-full"
              icon={{ name: 'calendar-days', style: 'fad' }}
              minDate={new Date()}
              id="resultTravelsDates"
            />
          )}
        />
      </div>

      <div className="p-6 lg:border-b lg:border-gray-200">
        <fieldset>
          <legend className="text-sm font-semibold uppercase mb-6">{t('form:categoryTravels')}</legend>

          {travelCategoryFilters?.map((category, index) => (
            <FormCheckbox
              key={`filter-category-${index}`}
              name="category"
              customLabel={() => category.name}
              className="mb-6 last:mb-0"
              value={category.id}
            />
          ))}
        </fieldset>
      </div>

      <div className="p-6 lg:border-b lg:border-gray-200">
        <fieldset>
          <legend className="text-sm font-semibold uppercase mb-6">{t('form:package')}</legend>

          {packageFilters?.map((pack, index) => (
            <FormCheckbox
              key={`filter-package-${index}`}
              name="package"
              customLabel={() => pack.name}
              className="mb-6 last:mb-0"
              value={pack.id}
            />
          ))}
        </fieldset>
      </div>

      <div className="p-6 mb-28 lg:pb-0 lg:mb-0">
        <fieldset>
          <legend className="text-sm font-semibold uppercase mb-6">{t('form:duration')}</legend>

          {nights.map((night, index) => (
            <FormCheckbox
              key={`filter-night-${index}`}
              name="nights"
              customLabel={() => night.name}
              className="mb-6 last:mb-0"
              value={`${night.value}`}
            />
          ))}
        </fieldset>
      </div>
    </>
  );
};

export default TravelsFilters;
